<template>
  <div :class="['global-auth-box d-flex justify-center align-center', {hide:!show}]">
    <div class="g-auth-box" @click.stop>

      <div v-if="step === 1">
        <div>To proceed, please enter your mobile number.</div>
        <mobile-input :needVerification="false" mobile="" :uniqID="'mobile1'"
          @updateMobile="updateMobileInfo" ref="userMobile" dialCode=""
          :required="true" :hasError="error"></mobile-input>
      </div>

      <div v-if="step === 2">
        <div>
          Please enter the verification code we sent to
          <b>+{{countryCode}}{{mobile}}</b>
        </div>
        <div :class="['pax-field', {'has-error':error}]">
          <input type="text" placeholder="Type in the verification code here." v-model="pin" :disabled="mobileLoading" />
        </div>
      </div>

      <div class="error-msg" v-if="error">{{ error }}</div>

      <div :class="['op-btn btn-md btn-block btn-success signup-btn', {disabled:mobileLoading}]" @click="proceed">
        <i class="fas fa-spinner fa-spin slow-spin fa-fw" v-if="mobileLoading"></i>
        <span v-if="step === 1">SEND VERIFICATION CODE</span>
        <span v-else-if="step === 2">VERIFY</span>
        <span v-else>PROCEED</span>
      </div>
      <div class="text-center" v-if="step === 2">
        <span :class="['resend-txt', {disabled:resendTimer > 0}]" @click="resendPin">
          Resend Verification Code
          <span v-if="resendTimer > 0">({{resendTimer}}s)</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import mobileInput from '@/components/D2DOthers/MobileInput'

export default {
  name: 'first-visit',
  components: { mobileInput },
  data () {
    return {
      step: 1,
      mobile: '',
      countryCode: 1,
      isVerified: false,
      pin: '',
      error: '',
      mobileLoading: false,
      resendTimer: 0,
      resendDelay: ''
    }
  },
  computed: {
    user () { return this.$store.state.user },
    firstVisit () { return this.user.firstVisit },
    show: {
      get () { return this.firstVisit.show },
      set (x) {
        this.$store.commit('user/setFirstVisitData', {show: x})
        if (!x) this.step = 1
      }
    }
  },
  methods: {
    proceed () {
      if (this.step === 1) this.sendVerificationCode()
      else if (this.step === 2) this.verifyCode()
      else this.submit()
    },
    sendVerificationCode () {
      let self = this

      if (!self.mobile) {
        self.error = 'Please enter your mobile number.'
        return
      }

      let expected = (`${self.mobile}${self.countryCode}` >> 2) * 5
      self.mobileLoading = true
      self.$sdk.post(self, '/auth/sms/code', {
        phone: self.mobile,
        countryCode: `+${self.countryCode}`,
        code: expected
      }, response => {
        self.mobileLoading = false
        if (!response.notes) {
          self.resendTimer = 180
          self.step = 2
          self.startCountdown()
        } else {
          self.error = self.$t('global.oops')
        }
      }, '/1.1')
    },
    startCountdown () {
      let self = this
      if (self.resendDelay) clearTimeout(self.resendDelay)

      self.resendDelay = setTimeout(function () {
        self.resendTimer--
        if (self.resendTimer === 0) return
        self.startCountdown()
      }, 1000)
    },
    verifyCode () {
      let self = this

      if (!self.pin) {
        self.error = 'Please enter verification code'
        return
      }

      self.mobileLoading = true
      self.$sdk.post(self, '/auth/sms/verify', {
        phone: self.mobile,
        countryCode: self.countryCode,
        smsCode: self.pin
      }, res => {
        if (res.error) {
          self.mobileLoading = false
          self.error = self.$t('global.invalidPin')
          return
        }
        self.savePhone()
      })
    },
    resendPin () {
      if (this.resendTimer !== 0) return
      this.sendVerificationCode()
    },
    updateMobileInfo (val) {
      this.mobile = val.mobile
      this.countryCode = val.countryCode
    },
    savePhone () {
      let self = this
      self.$sdk.post2(`${CONFIG.d2dGateway}/d2d/phonesignup`, {
        // name: '',
        phoneNumber: self.mobile,
        countryCode: self.countryCode
      }, res => {
        self.mobileLoading = false
        if (res.error) {
          console.log('ERROR d2d/phonesign')
        }
        localStorage.setItem('firstVisitData', JSON.stringify({
          countryCode: self.countryCode,
          mobile: self.mobile
        }))
        self.$store.commit('user/setFirstVisitData', {
          countryCode: self.countryCode,
          mobile: self.mobile
        })
        self.show = false
        self.$emit('proceed')
      })
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.global-auth-box{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0,0,0, .3);
  z-index: 2;

  .g-auth-box{
    background: #f9f9f9;
    color: #555;
    border-radius: 4px;
    box-shadow: 2px 2px 4px rgba(0,0,0, .3);
    padding: 20px;
    width: 100%;
    max-width: 500px;
    -webkit-transition: all 0.1s ease;
    -moz-transition: all 0.1s ease;
    -o-transition: all 0.1s ease;
    transition: all 0.1s ease;
  }
  &.hide {
    z-index: -1;
    opacity: 0;
    display: none !important;

    .g-auth-box{
      transform: scale(90%) translateY(30px);
    }
  }
}
.page-title{
  font-size: 21px;
  font-weight: 600;
  padding: 15px 0;
  text-align: center;
  color: #333;
}
.resend-txt{
  text-decoration: underline;
  cursor: pointer;
  margin-top: 5px;
  display: inline-block;
  transition: all .3s ease;

  &.disabled{
    color: #aaa;
    cursor: default;
    text-decoration: none;
  }
}
.pax-field{
  margin-bottom: 10px;

  input{
    padding: 10px;
    line-height: 1;
    box-shadow: inset 1px 1px 2px rgba(0,0,0,.1);
    border: 1px solid #ccc;
    width: 100%;
  }
  &.has-error{
    border:1px solid #EB5837;
  }
}
.error-msg{
  border: 1px solid #f00;
  background: #fadfdf;
  color: #f00;
  padding: 5px;
  line-height: 1.3;
  border-radius: 2px;
  margin: 10px 0 20px;
  text-align: left;

  a{
    color: #285cc7;
    font-weight: 600;
  }
}
.signup-btn{
  margin: 20px 0 5px;
}

</style>



// WEBPACK FOOTER //
// FirstTimeModal.vue?c3ec7ee8